const initialState = {
	list: [],
	page: 1,
	isListNext: false,
	count: 0,
	countOpen: 0,
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'MY_POST_LIST_SET') {
		let newState = Object.assign({}, state);

		let list = action.payload.list;
		newState.list = list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.count = action.payload.count;
		newState.countOpen = action.payload.countOpen;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'MY_POST_LIST_DATE_INIT') {
		let newState = Object.assign({}, state);
		newState.datetime = null;
		return newState;
	}
	else if (action.type === 'MY_POST_ITEM_SET') {
		let newState = Object.assign({}, state);
		let post = action.payload;
		let index = newState.list.findIndex((value) => value.post_id === post.post_id);
		if (index >= 0) {
			newState.list[index] = post;
		}
		else {
			newState.list.unshift(post);
		}
		newState.datetime = (new Date());
		return newState;
	}
	else {
		return state;
	}
}
